import React, { useState, useEffect, use } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login.js";
import Topbar from "./layout/topbar.js";
import "./App.css"; // Import the CSS file
import { CssBaseline, Container } from "@mui/material";

import Dashboard from "./pages/dashboard.js";
import Report from "./pages/report.js";
import CustomiseReport from "./pages/customiseReport.js";
import PrivateRoute from "./auth/privateRoute.js";
import { isAuthenticated } from "./auth/auth.js";
import axios from "axios";
import config from "./config.json";
import { Toaster } from "react-hot-toast";
import UserReports from "./pages/userReports.js";
import StartReport from "./pages/startReport.js";
import StressQuiz from "./pages/stressQuiz.js";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(isAuthenticated());
  const [showPopUp, setShowPopUp] = React.useState(false);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (isLoggedIn && !userData) {
      setUserData(JSON.parse(localStorage.getItem("userData")));
    }
  }, []);

  const handleStorageChange = async () => {
    const token = localStorage.getItem("token");
    console.log("Token changed", token);
    if (!token) {
      setIsLoggedIn(false);
    }
    if (token && !isLoggedIn) {
      setIsLoggedIn(true);
    }
  };

  const getUserData = async () => {
    try {
      await axios
        .get(`${config.apiBaseUrl}/user`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setUserData(response.data.user);
          localStorage.setItem("userData", JSON.stringify(response.data.user));
        });
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      getUserData();
    }
  }, [isLoggedIn]);

  const refreshUserData = async () => {
    if (isLoggedIn) {
      await getUserData();
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (document.visibilityState === "visible") {
        refreshUserData();
      }
    }, 300000); // 5 minutes in milliseconds

    const handleVisibilityChange = () => {
      const lastRefresh = localStorage.getItem("lastRefresh");
      const now = new Date().getTime();
      if (
        document.visibilityState === "visible" &&
        (!lastRefresh || now - lastRefresh > 300000)
      ) {
        console.log("Refreshing user data");
        refreshUserData();
        localStorage.setItem("lastRefresh", now);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <Router>
      <CssBaseline />
      <Toaster position="top-center" />
      <Routes>
        <Route path="/audit/report/:reportID" element={<Report />} />
        {/* <Route path="/start_audit" element={<StartReport />} /> */}
        {/* <Route path="/stress_quiz" element={<StressQuiz />} /> */}
        <Route
          path="/admin_login"
          element={isLoggedIn ? <Navigate to="/admin_console" /> : <Login />}
        />
        <Route
          path="*"
          element={
            <PrivateRoute>
              <>
                <Topbar setShowPopUp={setShowPopUp} userData={userData} />
                <Container maxWidth={false}>
                  <Routes>
                    <Route
                      path="/admin_console"
                      element={
                        <Dashboard
                          userData={userData}
                          refreshUserData={refreshUserData}
                        />
                      }
                    />
                    <Route
                      path="/reports"
                      element={<UserReports userData={userData} />}
                    />
                    {/* Add more routes as needed */}
                    <Route path="*" element={<Navigate to="/" />} />
                    <Route
                      path="/"
                      element={<Navigate to="/admin_console" />}
                    />
                  </Routes>
                </Container>
                <CustomiseReport
                  showPopUp={showPopUp}
                  setShowPopUp={setShowPopUp}
                />
              </>
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
